import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { TDownloadDocumentDialogProps } from './types';
import { versionTableStructure, TVersionRow } from './tableStructure';

export const DownloadDocumentDialog = ({
	open,
	fileName,
	versions,
	onClose,
	onDownload,
}: TDownloadDocumentDialogProps) => {
	const handleAction = (id: number, action: string) => {
		if (action === 'Download') {
			onDownload(id);
			onClose();
		}
	};

	return (
		<Dialog
			open={open}
			maxWidth="md"
			fullWidth
			sx={{
				'& .MuiDialog-paper': {
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">Download Document - {fileName}</DialogTitle>
			<DialogContent sx={{ p: '12px 24px' }}>
				<EasTableWithoutFilter<TVersionRow>
					tableStructure={versionTableStructure}
					items={{
						data: versions,
						pageNumber: 1,
						pageSize: versions.length || 10,
						totalCount: versions.length,
					}}
					itemsIsLoading={false}
					handleAction={handleAction}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
			</DialogActions>
		</Dialog>
	);
};
